<template>
  <el-dialog :visible.sync="dialogVisible" :title="dialogData.title" width="70%">
     <cs-table :tableCols="dialogData.isProgram == '节目'?tableCols:programsCols" :showPagination="false" :tableData="tableData">
      <template slot="control" slot-scope="scope" v-if="dialogData.title=='发布'">
        <el-button type="primary" size="mini" @click="releaseEvent(scope.row)">发布</el-button>
      </template>
    </cs-table>
    <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { fetchPushFlag, fetchSetsPushFlag } from '@/resource/api/index'

export default {
  name: 'DetailDialog',
  props: {
    dialogData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    dialogVisible (val) {
      if (!val) {
        this.tableData = []
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      form: {},
      tableData: [],
      tableCols: [
        { prop: 'name', label: '节目名称' },
        { prop: 'programSetName', label: '所属节目集' },
        { prop: 'seriesNo', label: '集号' },
        { prop: 'category', label: '分类' },
        { prop: 'pColumn', label: '栏目' },
        { prop: 'siteAppName', label: '推送站点' },
        {
          prop: 'sitePushFlag',
          label: '发布状态',
          formatter: function (row, column) {
            let stateText = ''
            switch (row.sitePushFlag) {
              case 0:
                stateText = '队列中'
                break
              case 1:
                stateText = '推送中'
                break
              case 2:
                stateText = '推送失败'
                break
              case 3:
                stateText = '推送成功'
                break
              case 4:
                stateText = '已下线'
                break
              case -1:
                stateText = '未推送'
                break
              case -5:
                stateText = '回调不推送'
                break
              case -999:
                stateText = '- -'
                break
            }
            return stateText
          }
        },
        { prop: 'auditTime', label: '审核时间' },
        { prop: 'createBy', label: '创建人' },
        { prop: 'createTime', label: '创建时间' },
        { prop: 'updateBy', label: '修改人' },
        { prop: 'updateTime', label: '修改时间' }
      ],
      programsCols: [
        { prop: 'category', label: '分类' },
        { prop: 'name', label: '节目集名称' },
        { prop: 'seriesAmount', label: '总集数' },
        { prop: 'newestSeriesNo', label: '最新集数' },
        { prop: 'siteAppName', label: '推送站点' },
        {
          prop: 'sitePushFlag',
          label: '发布状态',
          formatter: function (row, column) {
            let stateText = ''
            switch (row.sitePushFlag) {
              case 0:
                stateText = '队列中'
                break
              case 1:
                stateText = '推送中'
                break
              case 2:
                stateText = '推送失败'
                break
              case 3:
                stateText = '推送成功'
                break
              case 4:
                stateText = '已下线'
                break
              case -1:
                stateText = '未推送'
                break
              case -5:
                stateText = '回调不推送'
                break
              case -999:
                stateText = '- -'
                break
            }
            return stateText
          }
        },
        { prop: 'auditTime', label: '审核时间' },
        { prop: 'createBy', label: '创建人' },
        { prop: 'createTime', label: '创建时间' },
        { prop: 'updateBy', label: '修改人' },
        { prop: 'updateTime', label: '修改时间' }
      ]
    }
  },
  methods: {
    openDialog () {
      this.getData()
      this.dialogVisible = true
    },
    getData () {
      var row = this.dialogData.dataObj
      if (this.dialogData.isProgram == '节目') {
        const data = {
          id: row.id,
          companyId: this.$store.state.router.companyId
        }
        fetchPushFlag(data).then((res) => {
          if (res.code == '1') {
            this.tableData = []
            res.results.forEach(item => {
              if (item.sitePushFlag !== -999) {
                this.tableData.push({
                  name: row.name,
                  programSetName: row.programSetName,
                  siteAppName: item.siteAppName,
                  sitePushFlag: item.sitePushFlag,
                  seriesNo: row.seriesNo,
                  pColumn: row.pColumn,
                  category: row.category,
                  auditTime: this.$moment(row.auditTime).format('YYYY-MM-DD HH:mm:ss'),
                  createBy: row.createBy,
                  createTime: this.$moment(row.createTime).format('YYYY-MM-DD HH:mm:ss'),
                  updateBy: row.updateBy,
                  updateTime: this.$moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss')
                })
              }
            })
          }
        })
      } else {
        const data = {
          id: row.id,
          companyId: this.$store.state.router.companyId
        }
        fetchSetsPushFlag(data).then((res) => {
          if (res.code == '1') {
            this.tableData = []
            res.results.forEach(item => {
              if (item.sitePushFlag !== -999) {
                this.tableData.push({
                  name: row.name,
                  programSetName: row.programSetName,
                  siteAppName: item.siteAppName,
                  seriesAmount: row.seriesAmount,
                  newestSeriesNo: row.newestSeriesNo,
                  sitePushFlag: item.sitePushFlag,
                  seriesNo: row.seriesNo,
                  pColumn: row.pColumn,
                  category: row.category,
                  auditTime: this.$moment(row.auditTime).format('YYYY-MM-DD HH:mm:ss'),
                  createBy: row.createBy,
                  createTime: this.$moment(row.createTime).format('YYYY-MM-DD HH:mm:ss'),
                  updateBy: row.updateBy,
                  updateTime: this.$moment(row.updateTime).format('YYYY-MM-DD HH:mm:ss')
                })
              }
            })
          }
        })
      }
    }
  }
}
</script>
